<template>
  <div class="BookcaseRegister">
    <!-- <img class="code" src="https://open.weixin.qq.com/qr/code?username=geekuiot" alt=""> -->
    <img class="code" :src="companyInfo.offiaccount_url" alt="">
    <p class="text">请扫码关注公众号进行注册</p>
  </div>
</template>

<script>
import * as config from '../../../../static/js/config.js'
import { storage, messageError } from '../../../../static/js/utils/utility'
import { ECMallApi } from '../../../../static/Bookcase/js/api'
 import mqttws from './Mqttws'
let vm

export default {
  name:'BookcaseRegister',
  components: {
    mqttws
  },
  data() {
    return {
      codeUrl: '/static/images/gzhQrcode.jpg',
      companyInfo: {}
    }
  },
  created() {
    vm = this
    // vm.getQrcode()
    console.log('route', vm.$route)
    vm.companyInfo = vm.$store.state.ECMall_companyInfo
  },
  mounted () {
  },
  methods: {
    // 获取小程序码(注册)-弃用
    async getQrcode () {
      let data = {
        data:{
          "page": "pages/login/login",
          "scene": vm.companyInfo.company_ic + 'er' + '00000000'
        },
        mode: "getUnlimited",
        type: "er",
        company_id: vm.companyInfo.company_id
      }

      let res = await ECMallApi.getQrcode(data)
      if (res.meta.code === 200) {
        vm.codeUrl = res.data.image_url
      } else {
        messageError(res.meta.message)        
      }
    },
  },
  watch: {
  },
}
</script>

<style lang="less">
.Bookcase{
  .BookcaseRegister {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .code {
      width: 4.68rem;
      height: 4.68rem;
      margin: 2.55rem 0 0.46rem;
    }
    .text {
      color: #647de6;
      font-weight: bold;
      font-size: 0.58rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Common/Register.vue